import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import AdminLogin from "../component/auth/AdminLogin";
import Login from "../component/auth/Login";
import Dashboard from "../component/Dashboard";

import PrivateRoute from "./privateRoute";
import UserManagementRoutes from "./userManagementRoute";
import JobsRoutes from "./jobsRoutes";
import ForgotPassword from "../component/ForgotPassword";
import MyProfile from "../component/MyProfile";
import Category from "../component/Master/Category";
import SubCategory from "../component/Master/SubCategory";
import Product from "../component/Product";
import ResetPassword from "../component/ResetPassword";
import NewJob from "../component/NewJob";
import AddJob from "../component/NewJob/AddJob";
import Products from "../component/Products";
import Addons from "../component/Addons";
import DeliveryFormats from "../component/Master/DeliveryFormats";
import ArtworkPriceList from "../component/ArtworkPriceList";
import ArtworkProduct from "../component/ArtworkProduct";

const AppRoute = () => {
  return (
    <Router>
      <Routes>
        <Route path="/admin">
          <Route index element={<AdminLogin />} />

          <Route path="forgot-password" element={<ForgotPassword />} />

          <Route
            path="dashboard"
            exact
            element={
              <PrivateRoute moduleName="OPEN">
                <Dashboard isSupplierDashboard={0} />
              </PrivateRoute>
            }
          />

          <Route
            path="supplier-dashboard"
            exact
            element={
              <PrivateRoute moduleName="OPEN">
                <Dashboard isSupplierDashboard={1} />
              </PrivateRoute>
            }
          />

          <Route
            path="my-profile"
            element={
              <PrivateRoute moduleName="OPEN">
                <MyProfile />
              </PrivateRoute>
            }
          />

          <Route
            path="user-management/*"
            element={
              <PrivateRoute moduleName="USER_MANAGEMENT">
                <UserManagementRoutes />
              </PrivateRoute>
            }
          ></Route>

          <Route
            path="category"
            element={
              <PrivateRoute moduleName="MASTER">
                <Category />
              </PrivateRoute>
            }
          />

          <Route
            path="sub-category"
            element={
              <PrivateRoute moduleName="MASTER">
                <SubCategory />
              </PrivateRoute>
            }
          />

          <Route
            path="addon"
            element={
              <PrivateRoute moduleName="ADDON">
                <Addons />
              </PrivateRoute>
            }
          />

          <Route
            path="deliveryformat"
            element={
              <PrivateRoute moduleName="DELIVERY_FORMAT">
                <DeliveryFormats />
              </PrivateRoute>
            }
          />

          <Route
            path="new-job"
            element={
              <PrivateRoute moduleName="NEW_JOB">
                <NewJob />
              </PrivateRoute>
            }
          />

          <Route
            path="add-job"
            element={
              <PrivateRoute moduleName="NEW_JOB">
                <AddJob />
              </PrivateRoute>
            }
          />

          <Route
            path="jobs/*"
            element={
              <PrivateRoute moduleName="JOBS">
                <JobsRoutes />
              </PrivateRoute>
            }
          ></Route>

          <Route
            path="product"
            element={
              <PrivateRoute moduleName="PRODUCT">
                <Product />
              </PrivateRoute>
            }
          />

          <Route
            path="artwork-product"
            element={
              <PrivateRoute moduleName="ARTWORK_PRODUCT">
                <ArtworkProduct />
              </PrivateRoute>
            }
          />
        </Route>

        <Route path="/">
          <Route index element={<Login />} />

          <Route path="forgot-password" element={<ForgotPassword />} />

          <Route path="reset-password/:token" element={<ResetPassword />} />

          <Route
            path="dashboard"
            exact
            element={
              <PrivateRoute moduleName="OPEN">
                <Dashboard />
              </PrivateRoute>
            }
          />

          <Route
            path="my-profile"
            element={
              <PrivateRoute moduleName="OPEN">
                <MyProfile />
              </PrivateRoute>
            }
          />

          <Route
            path="new-job"
            element={
              <PrivateRoute moduleName="NEW_JOB">
                <NewJob />
              </PrivateRoute>
            }
          />

          <Route
            path="add-job"
            element={
              <PrivateRoute moduleName="NEW_JOB">
                <AddJob />
              </PrivateRoute>
            }
          />

          <Route
            path="jobs/*"
            element={
              <PrivateRoute moduleName="JOBS">
                <JobsRoutes />
              </PrivateRoute>
            }
          ></Route>

          {/* <Route
            path="products"
            element={
              <PrivateRoute moduleName="PRODUCTS">
                <Products />
              </PrivateRoute>
            }
          /> */}

          {/* <Route
            path="artwork-price-list"
            element={
              <PrivateRoute moduleName="ARTWORK_PRICE_LIST">
                <ArtworkPriceList />
              </PrivateRoute>
            }
          /> */}
        </Route>
      </Routes>
    </Router>
  );
};

export default React.memo(AppRoute);
